const MOTOR_POWER_PARAM_STD_TYPES = [230, 10993, 3, 6, 10994];
const WELL_EQUIPMENT_STATUS_PARAM_STD_TYPES = [1126, 186, 9, 189, 2, 1, 10, 187];
const SURFACE_POWER_OUTPUT_PARAM_STD_TYPES = [3, 6, 10993, 220];
const VDS_SETTING_PARAM_STD_TYPES = [0]; // TODO : Actual paramTypeIds for VDS settings need to be defined

export const ESP_CHARTS_PARAM_STD_TYPES = Array.from(
  new Set([
    ...MOTOR_POWER_PARAM_STD_TYPES,
    ...WELL_EQUIPMENT_STATUS_PARAM_STD_TYPES,
    ...SURFACE_POWER_OUTPUT_PARAM_STD_TYPES,
    ...VDS_SETTING_PARAM_STD_TYPES,
  ]),
);

export const MOTOR_POWER_ROWS = [
  [
    { label: 'Motor current', paramTypeId: '230', unit: '(amps)' },
    { label: 'Motor voltage (volts)', na: true, unit: 'V' },
  ],
  [
    { label: 'Motor nameplate amps', paramTypeId: '10993', unit: '(amps)' },
    { label: 'Motor', calcKva: true, unit: '(kVA)' },
  ],
  [
    { label: 'Motor load', calc: true, unit: '%' },
    { label: 'Motor OD', na: true, unit: '(inches)' },
  ],
  [
    { label: 'Active current leakage', paramTypeId: '10994', unit: '(mAmps)' },
    { label: '', na: true },
  ],
];

export const WELL_EQUIPMENT_STATUS_ROWS = [
  [
    { label: 'Status', paramTypeId: '1126', unit: '' },
    { label: 'Method of production', paramTypeId: '', unit: '', methodOfProduction: true },
  ],
  [
    { label: 'ESP supplier', paramTypeId: '', unit: '' },
    { label: 'ESP speed', paramTypeId: '2', unit: '(hz)' },
  ],
  [
    { label: 'Discharge pressure', paramTypeId: '186', unit: '(psi)' },
    { label: 'Intake pressure', paramTypeId: '1', unit: '(psi)' },
  ],
  [
    { label: 'Tubing head pressure', paramTypeId: '9', unit: '(psi)' },
    { label: 'Casing', paramTypeId: '10', unit: '(psi)' },
  ],
  [
    { label: 'Intake temperature', paramTypeId: '189', unit: '(deg F)' },
    { label: 'Motor temperature', paramTypeId: '187', unit: '(deg F)' },
  ],
  [
    { label: 'Vibration X', paramTypeId: '', unit: '(g)' },
    { label: 'Vibration Y', paramTypeId: '', unit: '(g)' },
  ],
];

export const SURFACE_POWER_OUTPUT_ROWS = [
  [
    { label: 'VSD output current A', paramTypeId: '3', unit: '(amps)' },
    { label: 'VSD output voltage AB', paramTypeId: '6', unit: '(volts)' },
  ],
  [
    { label: 'VSD nameplate amps', paramTypeId: '', unit: '10993' },
    { label: '% of VSD nameplate amps', calcVds: true, unit: '%' },
  ],
  [
    { label: 'Power (kVA)', calcKva: true, unit: '(kVA)' },
    { label: 'Power (kW)', paramTypeId: '220', unit: '(kW)' },
  ],
];

// TODO : Define the actual paramTypeId and unit for VDS settings
export const VDS_SETTING_ROWS = [
  [
    { label: 'Drive status', paramTypeId: '', unit: '' },
    { label: 'Last shutdown reason', paramTypeId: '', unit: '' },
  ],
  [
    { label: 'Motor underload', paramTypeId: '', unit: '' },
    { label: 'UL', paramTypeId: '', unit: '' },
  ],
  [
    { label: 'Motor overload', paramTypeId: '', unit: '' },
    { label: 'QL', paramTypeId: '', unit: '' },
  ],
  [
    { label: 'Max motor temp', paramTypeId: '', unit: '' },
    { label: 'Control mode', paramTypeId: '', unit: '' },
  ],
  [
    { label: 'Control variable', paramTypeId: '', unit: '' },
    { label: 'Control setpoint', paramTypeId: '', unit: '' },
  ],
  [
    { label: 'Min freq (hz)', paramTypeId: '', unit: '' },
    { label: 'Max freq (hz)', paramTypeId: '', unit: '' },
  ],
];

const GL_WELL_EQUIPMENT_STATUS_PARAM_STD_TYPES = [9, 152, 10, 185, 196, 191, 154, 141, 238, 209, 200];

export const GL_CHARTS_PARAM_STD_TYPES = Array.from(new Set([...GL_WELL_EQUIPMENT_STATUS_PARAM_STD_TYPES]));

export const GL_WELL_STATUS_ROWS = [
  [
    { label: 'Well', staticValueKey: 'Name' },
    { label: 'Tubing head pressure (psi)', paramTypeId: '9' },
    { label: 'Header pressure (psi)', paramTypeId: '152' },
  ],
  [
    { label: 'UWI', staticValueKey: 'Identifier' },
    { label: 'Casing pressure (psig)', paramTypeId: '10' },
    { label: 'Flowline pressure (psig)', paramTypeId: '185' },
  ],
  [
    { label: 'Method of production', staticValueKey: 'MethodOfProduction' },
    { label: 'Injection pressure (psig)', paramTypeId: '196' },
    { label: 'Flowline choke dP (psi)', calc: 'flowlineChokeDP' },
  ],
  [
    { label: 'Manufacturer', staticValue: 'Flowco' },
    { label: 'Injection rate (mscf/d)', paramTypeId: '191' },
    { label: 'Injection choke dP (psi)', na: true },
  ],
  [
    { label: 'SD valve status', paramTypeId: '154' },
    { label: 'Tubing temperature (deg F)', paramTypeId: '141' },
    { label: 'Compressor suction pressure (psi)', na: true },
  ],
  [
    { label: 'Injection path', calc: 'injectionPath' },
    { label: 'Downhole pressure (psi)', paramTypeId: '238' },
    { label: 'Compressor discharge pressure (psi)', na: true },
  ],
  [
    { label: 'Last Update', staticValueKey: 'LastUpdatedDate' },
    { label: 'Downhole temperature (deg F)', paramTypeId: '209' },
    { label: 'Compressor speed (rpm)', na: true },
  ],
  [
    { label: 'Injection rate setpoint (mscf/d)', paramTypeId: '200' },
    { label: 'Inj rate vs SP (mscf/d)', calc: 'deltaInjection' },
    { label: '', na: true },
  ],
];
